export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 35, order: "name" },
	{ name: "RUT", size: 30, order: "code" },
	{ name: "Giro", size: 20, order: "giro" },
	{ name: "Cliente", size: 20, order: "customer_name", only_admin: true },
	{ name: "Acción", size: 10, order: "" },
];
